import React from 'react';
import '../components-css/header.scss'
import Carousel from "react-material-ui-carousel";

export const Item = React.memo(({ elem }) => {
    return (
        <div className={elem}/>
    );
});

const ImageCarousel = ({items}) => {
    const [index, setIndex] = React.useState(0);

    const handleChange = (cur, _prev) => {
        setIndex(cur);
    };

    return (
        <Carousel
            index={index}
            onChange={handleChange}
            animation="slide"
            swipe={false}
            autoPlay={true}
            navButtonsAlwaysVisible={true}
            activeIndicatorIconButtonProps={{
                style: {
                    color:"#b31684"
                }
            }}
            indicatorContainerProps={{
                style: {
                    padding: "0 10%",
                }
            }}
            navButtonsWrapperProps={{
                style: {
                    height: "88%",
                    opacity: 0.6
                }
            }}
            className="my-carousel"
            height={'88%'}
            back
        >
            {items.map((item, i) => (
                <Item key={'image' + i} elem={item}/>
            ))}
        </Carousel>
    );
};

export default ImageCarousel;
